module.exports = __webpack_public_path__ + "static/media/Membership-card-pro.1381848f.png";